//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveClass: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/class/edit/save", vo, successCallback, failureCallback);
    }
};

export default EditService;